function getSortOptions() {
  return [
    {
      label: "All Properties",
      value: "all_properties",
    },
    {
      label: "Reserve price (Low to high)",
      value: "reserve_price_asc",
    },
    {
      label: "Reserve price (High to low)",
      value: "reserve_price_desc",
    },
    {
      label: (
        <p>
          Auction date <label className="text-red-500">(Approaching)</label>
        </p>
      ),
      value: "auction_date_asc",
    },
  ];
}

function getSortOption(data: any) {
  let prices = getSortOptions();
  return prices.filter((item: any) => {
    return data.slug.includes(item.value);
  });
}

export { getSortOptions, getSortOption };
